import { useState, useEffect, useRef } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Calendar } from 'react-date-range';
import * as locales from 'react-date-range/dist/locale';
import { toast } from 'react-toastify';

import Loader from '../Loader/Loader';
import './DateAndTime.css';

const DateAndTime = ({ changeData, sections, dataSelected }) => {
  const [dateValue, setDateValue] = useState(new Date());
  const [dateTime, setDateTime] = useState('');
  const [timeSlots, setTimeSlots] = useState([]);
  const [allSlots, setAllSlots] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (dataSelected?.serviciu?.service_id && dataSelected?.date) {
      const datePart = dataSelected.date.split(',')[0].trim();
      const [day, month, year] = datePart.split('-');
      const initDate = new Date(year, month - 1, day);
      if (dateValue.getTime() !== initDate.getTime()) {
        setDateValue(initDate);
      }
    }
  }, [dataSelected?.serviciu?.service_id, dataSelected?.date]);

  useEffect(() => {
    if (dataSelected?.serviciu?.service_id) {
      const fetchAvailableDates = async () => {
        setLoading(true);
        try {
          const response = await fetch(
            '/server/zoho_booking_custom_ui_function/available-dates',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                service_id: dataSelected.serviciu.service_id,
              }),
            }
          );
          const dataResponse = await response.json();
          if (dataResponse.code === 3000) {
            const parsedResult = JSON.parse(dataResponse.result);
            if (parsedResult.status === 'success') {
              if (isMounted.current) setAllSlots(parsedResult.data);
            } else if (parsedResult.status === 'failure') {
              toast.error(parsedResult.data, {
                position: 'top-center',
                autoClose: 5000,
                theme: 'colored',
              });
              if (isMounted.current) setAllSlots([]);
            }
          } else {
            toast.error('Something went wrong!', {
              position: 'top-center',
              autoClose: 5000,
              theme: 'colored',
            });
            if (isMounted.current) setAllSlots([]);
          }
        } catch (err) {
          toast.error('Something went wrong!', {
            position: 'top-center',
            autoClose: 5000,
            theme: 'colored',
          });
          if (isMounted.current) setAllSlots([]);
        } finally {
          if (isMounted.current) setLoading(false);
        }
      };
      fetchAvailableDates();
    }
  }, [dataSelected?.serviciu?.service_id]);

  useEffect(() => {
    if (allSlots) {
      const formattedDate = `${dateValue
        .getDate()
        .toString()
        .padStart(2, '0')}-${(dateValue.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${dateValue.getFullYear()}`;
      const availableSlots = allSlots.filter(
        (slot) => slot.date === formattedDate
      );
      setTimeSlots(availableSlots);
    }
  }, [allSlots, dateValue]);

  const handleSelect = (date) => {
    if (date.getTime() === dateValue.getTime()) return;
    setDateValue(date);
  };

  const handleDateChange = (slot) => {
    const formattedDate = `${dateValue
      .getDate()
      .toString()
      .padStart(2, '0')}-${(dateValue.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dateValue.getFullYear()}`;
    setDateTime(slot.start_time);
    changeData(`${formattedDate}, ${slot.start_time}, ${slot.slot_id}`);
  };

  const customDayContent = (day) => {
    const formatted = `${day.getDate().toString().padStart(2, '0')}-${(
      day.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${day.getFullYear()}`;

    const isAvailable =
      allSlots && allSlots.some((slot) => slot.date === formatted);

    return (
      <div>
        {isAvailable && <div className="customBackgroundDay" />}
        <span>{day.getDate()}</span>
      </div>
    );
  };

  return (
    <div>
      <h6 style={{ fontSize: '0.9rem', color: 'red' }} className="text-center">
        Step 1: Choose your booking date
      </h6>
      {!sections.section3 && (
        <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Calendar
              locale={locales['enGB']}
              date={dateValue}
              color="var(--custom-primary-color)"
              minDate={new Date()}
              maxDate={
                new Date(new Date().setFullYear(new Date().getFullYear() + 1))
              }
              onChange={handleSelect}
              dayContentRenderer={customDayContent}
            />
          </div>

          <hr />

          <h6 style={{ fontSize: '0.9rem', color: 'red' }}>
            Step 2: Choose your timeslot
          </h6>

          <div className="row mt-5 text-center">
            {loading ? (
              <Loader />
            ) : timeSlots.length > 0 ? (
              timeSlots.map((slot, i) => (
                <div key={i} className="col-md-3 col-xs-8 col-sm-6 mb-4">
                  <button
                    type="button"
                    style={{ width: '100%' }}
                    onClick={() => handleDateChange(slot)}
                    className={`btn btn-sm ${
                      slot.start_time === dateTime
                        ? 'btn-primary'
                        : 'btn-outline-primary'
                    }`}
                  >
                    {slot.start_time}
                  </button>
                </div>
              ))
            ) : (
              <span
                style={{
                  fontWeight: 'bold',
                  color: 'var(--custom-primary-color)',
                }}
              >
                Not available
              </span>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DateAndTime;
